import React, { useState, useEffect, useRef } from 'react';
import './App.css';

// ==================== KONFIGURACJA ====================
const CONFIG = {
  quizStartDate: new Date('2025-12-05T00:00:00'),
  quizEndDate: new Date('2025-12-26T23:59:59'),
  resultsDate: new Date('2025-12-27T12:00:00'),
  bingoEndDate: new Date('2025-12-31T23:59:59'),
  maxAttempts: 2,
  questionsCount: 10,
  timePerQuestion: 15,
  promoCode: 'WIGILIA',
  promoDeadline: '20.12',
  facebookPageUrl: 'https://www.facebook.com/michapupilapl',
  facebookAppId: '377009217757010',
};

// Sprawdź czy quiz się zakończył
const isQuizEnded = () => new Date() > CONFIG.quizEndDate;
const isQuizActive = () => {
  const now = new Date();
  return now >= CONFIG.quizStartDate && now <= CONFIG.quizEndDate;
};
const isBingoActive = () => new Date() <= CONFIG.bingoEndDate;

// ==================== PYTANIA USUNIĘTE ====================
// Wszystkie pytania są teraz TYLKO na serwerze!
// Plik: netlify/functions/quiz-data.js

// ==================== NAGRODY MIKOŁAJA ====================
const santaPrizes = [
  { id: 1, code: 'XMAS10', label: '10% rabatu', image: '/images/box-10.png', weight: 30 },
  { id: 2, code: 'ELF5', label: '5 zł rabatu', image: '/images/box-5zl.png', weight: 25 },
  { id: 3, code: 'SUPLE20', label: '20% na suplementy', image: '/images/box-suplement.png', weight: 20 },
  { id: 4, code: 'PRZYS10', label: '10% na przysmaki', image: '/images/box-przysmak.png', weight: 15 },
];

// ==================== ZADANIA BINGO ====================
const bingoTasks = [
  { id: 1, icon: '🛒', label: 'Złóż zamówienie', description: 'Zamów w terminie 1-26.12' },
  { id: 2, icon: '💊', label: 'Zamów suplement', description: 'Dodaj suplement do zamówienia' },
  { id: 3, icon: '🦴', label: 'Zamów przysmak', description: 'Dodaj przysmak do zamówienia' },
  { id: 4, icon: '👯', label: 'Poleć nas', description: 'Poleć znajomemu' },
  { id: 5, icon: '🎮', label: 'Ukończ Quiz', description: 'Weź udział w quizie' },
  { id: 6, icon: '👍', label: 'Polub na FB', description: 'Polub naszą stronę', type: 'facebook' },
  { id: 7, icon: '📧', label: 'Newsletter', description: 'Zapisz się na newsletter', type: 'newsletter' },
  { id: 8, icon: '🔄', label: 'Zamów 2x', description: '2 zamówienia w grudniu' },
];

// ==================== ZESTAWY PREZENTOWE ====================
const giftSets = [
  { id: 1, image: '/images/zestaw-swiat-suple.jpg', name: '3 Suplementy', description: 'Zestaw 3 wybranych suplementów dla pupila' },
  { id: 2, image: '/images/ZESTAW-PREZENTOWY_treerki_suple.jpg', name: 'Suplement + Treserki', description: 'Wybrany suplement + wybrane treserki' },
  { id: 3, image: '/images/ZESTAW-PREZENTOWY_psisuszone_suple.jpg', name: 'Suplement + Psisuszone', description: 'Wybrany suplement + wybrany smak suszonego mięsa' },
  { id: 4, image: '/images/ZESTAW-PREZENTOWY_dosmaczacz_suple.jpg', name: 'Suplement + Psiprawa', description: 'Wybrany suplement + wybrany psiprawa dla psa' },
  { id: 5, image: '/images/ZESTAW-PREZENTOWY_psielbaski+suple.jpg', name: 'Suplement + Psiełbaski', description: 'Wybrany suplement + wybrane psiełbaski dla psa' },
];

// ==================== HELPER: Local Storage ====================
const storage = {
  get: (key, defaultValue = null) => {
    try {
      const item = localStorage.getItem(`michapupila_${key}`);
      return item ? JSON.parse(item) : defaultValue;
    } catch {
      return defaultValue;
    }
  },
  set: (key, value) => {
    try {
      localStorage.setItem(`michapupila_${key}`, JSON.stringify(value));
    } catch (e) {
      console.error('Storage error:', e);
    }
  },
  remove: (key) => {
    try {
      localStorage.removeItem(`michapupila_${key}`);
    } catch (e) {
      console.error('Storage error:', e);
    }
  }
};

// ==================== HELPER: Fingerprint ====================
const getVisitorId = async () => {
  try {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('fingerprint', 2, 2);
    
    const data = [
      navigator.userAgent,
      navigator.language,
      screen.width + 'x' + screen.height,
      new Date().getTimezoneOffset(),
      canvas.toDataURL()
    ].join('|');
    
    let hash = 0;
    for (let i = 0; i < data.length; i++) {
      const char = data.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(36);
  } catch {
    return 'unknown';
  }
};

// ==================== API HELPERS (BEZPIECZNE) ====================
const api = {
  validateOrder: async (orderId, visitorId) => {
    try {
      const response = await fetch('/.netlify/functions/validate-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orderId, visitorId })
      });
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      return { valid: false, error: 'Błąd połączenia' };
    }
  },
  
  startQuiz: async (data) => {
    try {
      const response = await fetch('/.netlify/functions/start-quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      return { success: false, error: 'Błąd połączenia' };
    }
  },
  
  submitAnswer: async (sessionToken, questionIndex, answerIndex, timeSpent) => {
    try {
      const response = await fetch('/.netlify/functions/submit-answer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionToken, questionIndex, answerIndex, timeSpent })
      });
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      return { success: false, error: 'Błąd połączenia' };
    }
  },
  
  finishQuiz: async (sessionToken) => {
    try {
      const response = await fetch('/.netlify/functions/finish-quiz', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionToken })
      });
      return response.json();
    } catch (error) {
      console.error('API Error:', error);
      return { success: false, error: 'Błąd połączenia' };
    }
  },
  
  getLeaderboard: async (limit = 50) => {
    try {
      const response = await fetch(`/.netlify/functions/get-leaderboard?limit=${limit}`);
      const data = await response.json();
      return {
        success: data.success,
        entries: data.entries || []
      };
    } catch (error) {
      console.error('API Error:', error);
      return { success: false, entries: [] };
    }
  }
};

// ==================== GŁÓWNY KOMPONENT ====================
function App() {
  // Stan aplikacji
  const [currentView, setCurrentView] = useState('home');
  const [orderId, setOrderId] = useState('');
  const [customerId, setCustomerId] = useState(() => storage.get('customerId', ''));
  const [playerName, setPlayerName] = useState('');
  const [petName, setPetName] = useState('');
  const [petType, setPetType] = useState('dog');
  const [isValidOrder, setIsValidOrder] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [maxAttemptsReached, setMaxAttemptsReached] = useState(false);
  const [visitorId, setVisitorId] = useState('');
  
  // Stan quizu - BEZPIECZNY (zarządzany przez serwer)
  const [sessionToken, setSessionToken] = useState(null);
  const [quizQuestions, setQuizQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(CONFIG.timePerQuestion);
  const [answers, setAnswers] = useState([]);
  const [quizStartTime, setQuizStartTime] = useState(null);
  const [quizEndTime, setQuizEndTime] = useState(null);
  const [isAnswered, setIsAnswered] = useState(false);
  const [quizResults, setQuizResults] = useState(null);
  
  // Stan prezentów Mikołaja
  const [selectedPrize, setSelectedPrize] = useState(null);
  const [showGiftAnimation, setShowGiftAnimation] = useState(false);
  const [showGiftResult, setShowGiftResult] = useState(false);
  const [hasClaimedGift, setHasClaimedGift] = useState(() => storage.get('hasClaimedGift', false));
  const [claimedPrize, setClaimedPrize] = useState(() => storage.get('claimedPrize', null));
  
  // Stan Bingo
  const [completedTasks, setCompletedTasks] = useState(() => storage.get('completedTasks', []));
  const [bingoCustomerId, setBingoCustomerId] = useState(() => storage.get('bingoCustomerId', ''));
  const [bingoEmail, setBingoEmail] = useState(() => storage.get('bingoEmail', ''));
  const [bingoName, setBingoName] = useState(() => storage.get('bingoName', ''));
  const [bingoSubmitted, setBingoSubmitted] = useState(() => storage.get('bingoSubmitted', false));
  
  // Modals
  const [showFacebookModal, setShowFacebookModal] = useState(false);
  const [showNewsletterModal, setShowNewsletterModal] = useState(false);
  const [showBingoSubmitModal, setShowBingoSubmitModal] = useState(false);
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [isSubmittingNewsletter, setIsSubmittingNewsletter] = useState(false);
  const [newsletterSuccess, setNewsletterSuccess] = useState(false);
  const [isSubmittingBingo, setIsSubmittingBingo] = useState(false);
  const [bingoSubmitSuccess, setBingoSubmitSuccess] = useState(false);
  const [showCustomerIdHelp, setShowCustomerIdHelp] = useState(false);
  
  // Ranking
  const [leaderboard, setLeaderboard] = useState([]);
  const [playerRank, setPlayerRank] = useState(null);
  
  // Loading states
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const timerRef = useRef(null);
  const featuresRef = useRef(null);

  // ==================== INICJALIZACJA ====================
  useEffect(() => {
    getVisitorId().then(setVisitorId);
    
    // Pobierz ranking z serwera
    api.getLeaderboard().then(data => {
      if (data.success && data.entries) {
        setLeaderboard(data.entries);
      }
    });
  }, []);

  // ==================== PERSYSTENCJA ====================
  useEffect(() => {
    storage.set('completedTasks', completedTasks);
  }, [completedTasks]);

  useEffect(() => {
    storage.set('hasClaimedGift', hasClaimedGift);
  }, [hasClaimedGift]);

  useEffect(() => {
    storage.set('claimedPrize', claimedPrize);
  }, [claimedPrize]);

  useEffect(() => {
    storage.set('customerId', customerId);
  }, [customerId]);

  useEffect(() => {
    storage.set('bingoCustomerId', bingoCustomerId);
  }, [bingoCustomerId]);

  useEffect(() => {
    storage.set('bingoEmail', bingoEmail);
  }, [bingoEmail]);

  useEffect(() => {
    storage.set('bingoName', bingoName);
  }, [bingoName]);

  useEffect(() => {
    storage.set('bingoSubmitted', bingoSubmitted);
  }, [bingoSubmitted]);

  // Scroll to features
  const scrollToFeatures = () => {
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  // ==================== TIMER QUIZU ====================
  useEffect(() => {
    if (currentView === 'quiz' && timeLeft > 0 && !isAnswered) {
      timerRef.current = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
    } else if (timeLeft === 0 && !isAnswered) {
      handleTimeout();
    }
    return () => clearTimeout(timerRef.current);
  }, [currentView, timeLeft, isAnswered]);

  // ==================== NEWSLETTER ====================
  const handleNewsletterSubmit = async () => {
    if (!newsletterEmail || !newsletterEmail.includes('@')) {
      alert('Podaj poprawny email');
      return;
    }

    setIsSubmittingNewsletter(true);

    try {
      const response = await fetch('/.netlify/functions/newsletter', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: newsletterEmail,
          customerId: bingoCustomerId || customerId
        })
      });

      const data = await response.json();

      if (data.success) {
        setNewsletterSuccess(true);
        toggleBingoTask(7);
        setTimeout(() => {
          setShowNewsletterModal(false);
          setNewsletterSuccess(false);
          setNewsletterEmail('');
        }, 2000);
      } else {
        alert('Subscription failed: ' + (data.error || 'Wystąpił błąd. Spróbuj ponownie.'));
      }
    } catch (error) {
      console.error('Newsletter error:', error);
      alert('Wystąpił błąd połączenia. Spróbuj ponownie.');
    }

    setIsSubmittingNewsletter(false);
  };

  // ==================== BINGO SUBMIT ====================
  const handleBingoSubmit = async () => {
    if (!bingoCustomerId) {
      alert('Podaj swoje ID klienta');
      return;
    }

    setIsSubmittingBingo(true);

    try {
      const response = await fetch('/.netlify/functions/bingo-submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: bingoCustomerId,
          customerEmail: bingoEmail,
          customerName: bingoName,
          completedTasks: completedTasks,
          totalTasks: bingoTasks.length,
          expectedDiscount: getBingoReward()?.discount || 'Brak'
        })
      });

      const data = await response.json();

      if (data.success) {
        setBingoSubmitSuccess(true);
        setBingoSubmitted(true);
        setTimeout(() => {
          setShowBingoSubmitModal(false);
          setBingoSubmitSuccess(false);
        }, 3000);
      } else {
        alert(data.error || 'Wystąpił błąd. Spróbuj ponownie.');
      }
    } catch (error) {
      console.error('Bingo submit error:', error);
      alert('Wystąpił błąd połączenia. Spróbuj ponownie.');
    }

    setIsSubmittingBingo(false);
  };

  // ==================== WALIDACJA ZAMÓWIENIA (BEZPIECZNA) ====================
  const validateOrderId = async () => {
    if (!orderId || orderId.length < 4) return;
    
    setIsLoading(true);
    
    try {
      const result = await api.validateOrder(orderId, visitorId);
      
      setIsValidOrder(result.valid);
      
      if (result.valid) {
        setAttempts(result.attempts || 0);
        if (result.attempts >= (result.maxAttempts || CONFIG.maxAttempts)) {
          setMaxAttemptsReached(true);
        }
      }
    } catch (error) {
      console.error('Validation error:', error);
      setIsValidOrder(false);
    }
    
    setIsLoading(false);
  };

  // ==================== ROZPOCZĘCIE QUIZU (BEZPIECZNE) ====================
  const startQuiz = async () => {
    setIsLoading(true);
    
    try {
      const result = await api.startQuiz({
        orderId,
        customerId,
        playerName,
        petName,
        petType,
        visitorId
      });
      
      if (result.success) {
        setSessionToken(result.sessionToken);
        setQuizQuestions(result.questions);
        setCurrentQuestion(0);
        setScore(0);
        setAnswers([]);
        setTimeLeft(result.timePerQuestion || CONFIG.timePerQuestion);
        setQuizStartTime(result.startTime || Date.now());
        setIsAnswered(false);
        setQuizResults(null);
        setCurrentView('quiz');
      } else {
        alert(result.error || 'Nie udało się rozpocząć quizu');
      }
    } catch (error) {
      console.error('Start quiz error:', error);
      alert('Błąd połączenia z serwerem');
    }
    
    setIsLoading(false);
  };

  // ==================== ODPOWIEDŹ NA PYTANIE (BEZPIECZNA) ====================
  const handleAnswer = async (answerIndex) => {
    if (isAnswered || !sessionToken) return;
    
    setIsAnswered(true);
    clearTimeout(timerRef.current);
    
    const timeSpent = CONFIG.timePerQuestion - timeLeft;
    
    try {
      const result = await api.submitAnswer(
        sessionToken,
        currentQuestion,
        answerIndex,
        timeSpent
      );
      
      if (result.success) {
        setAnswers([...answers, { questionIndex: currentQuestion, answerIndex, timeSpent }]);
        
        setTimeout(() => {
          if (result.isLastQuestion) {
            finishQuiz();
          } else {
            setCurrentQuestion(result.currentQuestion);
            setTimeLeft(CONFIG.timePerQuestion);
            setIsAnswered(false);
          }
        }, 500);
      } else {
        console.error('Submit answer error:', result.error);
        // Kontynuuj mimo błędu
        if (currentQuestion + 1 < quizQuestions.length) {
          setCurrentQuestion(currentQuestion + 1);
          setTimeLeft(CONFIG.timePerQuestion);
          setIsAnswered(false);
        } else {
          finishQuiz();
        }
      }
    } catch (error) {
      console.error('Submit answer error:', error);
    }
  };

  // ==================== TIMEOUT ====================
  const handleTimeout = async () => {
    if (!sessionToken) return;
    
    setIsAnswered(true);
    
    try {
      const result = await api.submitAnswer(
        sessionToken,
        currentQuestion,
        -1,
        CONFIG.timePerQuestion
      );
      
      setTimeout(() => {
        if (result.isLastQuestion) {
          finishQuiz();
        } else {
          setCurrentQuestion(result.currentQuestion);
          setTimeLeft(CONFIG.timePerQuestion);
          setIsAnswered(false);
        }
      }, 500);
    } catch (error) {
      console.error('Timeout error:', error);
      if (currentQuestion + 1 < quizQuestions.length) {
        setCurrentQuestion(currentQuestion + 1);
        setTimeLeft(CONFIG.timePerQuestion);
        setIsAnswered(false);
      } else {
        finishQuiz();
      }
    }
  };

  // ==================== ZAKOŃCZENIE QUIZU (BEZPIECZNE) ====================
  const finishQuiz = async () => {
    if (!sessionToken) return;
    
    setIsSubmitting(true);
    
    try {
      const result = await api.finishQuiz(sessionToken);
      
      if (result.success) {
        setQuizResults(result);
        setScore(result.score);
        setQuizEndTime(Date.now());
        setPlayerRank(result.rank);
        setAttempts(result.attempts || attempts + 1);
        
        // Oznacz quiz jako ukończony w Bingo
        if (!completedTasks.includes(5)) {
          setCompletedTasks([...completedTasks, 5]);
        }
        
        // Odśwież ranking
        const leaderboardData = await api.getLeaderboard();
        if (leaderboardData.success && leaderboardData.entries) {
          setLeaderboard(leaderboardData.entries);
        }
      } else {
        console.error('Finish quiz error:', result.error);
      }
    } catch (error) {
      console.error('Finish quiz error:', error);
    }
    
    setSessionToken(null);
    setIsSubmitting(false);
    setCurrentView('results');
  };

  // ==================== FUNKCJE PREZENTÓW ====================
  const selectGift = (giftIndex) => {
    if (hasClaimedGift) return;
    
    const totalWeight = santaPrizes.reduce((sum, p) => sum + p.weight, 0);
    let random = Math.random() * totalWeight;
    let selectedPrizeData = santaPrizes[0];
    
    for (const prize of santaPrizes) {
      random -= prize.weight;
      if (random <= 0) {
        selectedPrizeData = prize;
        break;
      }
    }
    
    setSelectedPrize(selectedPrizeData);
    setClaimedPrize(selectedPrizeData);
    setShowGiftAnimation(true);
    
    setTimeout(() => {
      setShowGiftAnimation(false);
      setShowGiftResult(true);
      setHasClaimedGift(true);
    }, 1500);
  };

  const copyPrizeCode = () => {
    const prize = selectedPrize || claimedPrize;
    if (prize) {
      navigator.clipboard.writeText(prize.code);
      alert('Kod skopiowany! 🎁');
    }
  };

  // ==================== FUNKCJE BINGO ====================
  const toggleBingoTask = (taskId) => {
    if (completedTasks.includes(taskId)) {
      setCompletedTasks(completedTasks.filter(id => id !== taskId));
    } else {
      setCompletedTasks([...completedTasks, taskId]);
    }
  };

  const handleBingoClick = (task) => {
    if (task.type === 'facebook') {
      setShowFacebookModal(true);
      return;
    }
    if (task.type === 'newsletter') {
      setShowNewsletterModal(true);
      return;
    }
    toggleBingoTask(task.id);
  };

  const getBingoReward = () => {
    const completed = completedTasks.length;
    if (completed >= 8) return { discount: '30%', label: 'Pełne Bingo! 🎉' };
    if (completed >= 7) return { discount: '20%', label: '7 zadań' };
    if (completed >= 6) return { discount: '15%', label: '6 zadań' };
    return null;
  };

  // ==================== RENDEROWANIE ====================
  
  const renderHome = () => (
    <div className="home-container">
      {/* Hero Section */}
      <section className="hero-section" onClick={scrollToFeatures} style={{ cursor: 'pointer' }}>
        <img src="/images/SWIETA-QUIZ.jpg" alt="Magiczne Święta z Michą Pupila" className="hero-image" />
      </section>

      {/* Features Section */}
      <section className="features-section" ref={featuresRef}>
        <div className="section-container">
          <h2 className="section-title">Jak <span>wygrywać?</span> 🎁</h2>
          <p className="section-subtitle">Trzy zabawy, w których Twój pupil może wygrać prezenty spod choinki! 🐾</p>
          <div className="features-grid">
            {isQuizEnded() ? (
              <div className="feature-card feature-card-ended" onClick={() => setCurrentView('home')}>
                <div className="feature-image-container">
                  <img src="/images/quiz-icon.png" alt="Quiz" className="feature-image" />
                </div>
                <h3>🏁 Quiz Zakończony!</h3>
                <p>Dziękujemy wszystkim uczestnikom! Quiz dobiegł końca 26 grudnia. Sprawdź wyniki poniżej!</p>
                <div className="feature-prize">
                  <div className="feature-prize-label">Status</div>
                  <div className="feature-prize-value">Zakończony 26.12</div>
                </div>
                <button className="feature-btn feature-btn-ended">Zobacz wyniki ↓</button>
              </div>
            ) : (
              <div className="feature-card" onClick={() => setCurrentView('quiz-start')}>
                <div className="feature-image-container">
                  <img src="/images/quiz-icon.png" alt="Quiz" className="feature-image" />
                </div>
                <h3>Świąteczny Quiz</h3>
                <p>Sprawdź, czy znasz swojego pupila lepiej niż on zna miejsce, gdzie chowasz smakołyki!</p>
                <div className="feature-prize">
                  <div className="feature-prize-label">Do wygrania</div>
                  <div className="feature-prize-value">Miesiąc karmy gratis!</div>
                </div>
                <button className="feature-btn">Zagraj →</button>
              </div>
            )}

            <div className="feature-card" onClick={() => setCurrentView('santa-gifts')}>
              <div className="feature-image-container">
                <img src="/images/mikolaj-icon.png" alt="Mikołaj" className="feature-image" />
              </div>
              <h3>Prezenty od Mikołaja</h3>
              <p>Mikołaj ma w worku coś specjalnego dla Twojego pupila! Wybierz paczkę i zobacz, co dla Was przygotował 🎁</p>
              <div className="feature-prize">
                <div className="feature-prize-label">Nagrody</div>
                <div className="feature-prize-value">Rabaty, punkty, zniżki!</div>
              </div>
              <button className="feature-btn">Sprawdź →</button>
            </div>

            <div className="feature-card" onClick={() => setCurrentView('bingo')}>
              <div className="feature-image-container">
                <img src="/images/bingo-icon.png" alt="Bingo" className="feature-image" />
              </div>
              <h3>Świąteczne Bingo</h3>
              <p>Zbieraj gwiazdki jak Twój pupil zbiera smakołyki! Im więcej zadań, tym większy rabat 🌟</p>
              <div className="feature-prize">
                <div className="feature-prize-label">Nagroda</div>
                <div className="feature-prize-value">Do 30% rabatu!</div>
              </div>
              <button className="feature-btn">Zobacz →</button>
            </div>
          </div>
        </div>
      </section>

      {/* Prizes / Results Section */}
      <section className="prizes-section">
        <div className="section-container">
          {isQuizEnded() ? (
            <>
              <h2 className="section-title">🏆 <span>Wyniki Quizu</span> 🏆</h2>
              <p className="section-subtitle">Gratulacje dla zwycięzców! Oto TOP 3 tegorocznego Świątecznego Quizu! 🎄</p>
              
              <div className="prizes-podium">
                {leaderboard.length >= 2 && (
                  <div className="prize-item second">
                    <div className="prize-medal">🥈</div>
                    <div className="prize-place">2. MIEJSCE</div>
                    <div className="winner-info">
                      <div className="winner-pet">{leaderboard[1]?.petType === 'cat' ? '🐈' : '🐕'} {leaderboard[1]?.petName}</div>
                      <div className="winner-player">{leaderboard[1]?.playerName}</div>
                      <div className="winner-score">{leaderboard[1]?.score}/{leaderboard[1]?.totalQuestions || CONFIG.questionsCount} • {leaderboard[1]?.totalTime}s</div>
                    </div>
                    <div className="prize-text">
                      Wygrywa Michę Pupila<br/><strong>na 2 tygodnie!</strong>
                    </div>
                  </div>
                )}
                
                {leaderboard.length >= 1 && (
                  <div className="prize-item first">
                    <div className="prize-medal">🥇</div>
                    <div className="prize-place">1. MIEJSCE</div>
                    <div className="winner-info">
                      <div className="winner-pet">{leaderboard[0]?.petType === 'cat' ? '🐈' : '🐕'} {leaderboard[0]?.petName}</div>
                      <div className="winner-player">{leaderboard[0]?.playerName}</div>
                      <div className="winner-score">{leaderboard[0]?.score}/{leaderboard[0]?.totalQuestions || CONFIG.questionsCount} • {leaderboard[0]?.totalTime}s</div>
                    </div>
                    <div className="prize-text">
                      Wygrywa Michę Pupila<br/><strong>na miesiąc!</strong>
                    </div>
                  </div>
                )}
                
                {leaderboard.length >= 3 && (
                  <div className="prize-item third">
                    <div className="prize-medal">🥉</div>
                    <div className="prize-place">3. MIEJSCE</div>
                    <div className="winner-info">
                      <div className="winner-pet">{leaderboard[2]?.petType === 'cat' ? '🐈' : '🐕'} {leaderboard[2]?.petName}</div>
                      <div className="winner-player">{leaderboard[2]?.playerName}</div>
                      <div className="winner-score">{leaderboard[2]?.score}/{leaderboard[2]?.totalQuestions || CONFIG.questionsCount} • {leaderboard[2]?.totalTime}s</div>
                    </div>
                    <div className="prize-text">
                      Wygrywa Michę Pupila<br/><strong>na tydzień!</strong>
                    </div>
                  </div>
                )}

                {leaderboard.length === 0 && (
                  <div className="no-winners">
                    <p>Brak wyników do wyświetlenia</p>
                  </div>
                )}
              </div>
              
              <div className="results-note">
                <p>🎁 Zwycięzcy otrzymają wiadomość email z informacją o odbiorze nagrody.</p>
              </div>
            </>
          ) : (
            <>
              <h2 className="section-title">Nagrody <span>do wygrania</span> 🏆</h2>
              <p className="section-subtitle">TOP 3 w quizie zgarnia świąteczne pyszności dla pupila!</p>
              
              <div className="prizes-podium">
                <div className="prize-item second">
                  <div className="prize-medal">🥈</div>
                  <div className="prize-place">2. MIEJSCE</div>
                  <div className="prize-image">
                    <img src="/images/2-miejsce.png" alt="Nagroda za 2. miejsce" />
                  </div>
                  <div className="prize-text">
                    Micha Pupila<br/><strong>na 2 tygodnie</strong>
                  </div>
                </div>
                
                <div className="prize-item first">
                  <div className="prize-medal">🥇</div>
                  <div className="prize-place">1. MIEJSCE</div>
                  <div className="prize-image">
                    <img src="/images/1-miejsce.png" alt="Nagroda za 1. miejsce" />
                  </div>
                  <div className="prize-text">
                    Micha Pupila<br/><strong>na miesiąc!</strong>
                  </div>
                </div>
                
                <div className="prize-item third">
                  <div className="prize-medal">🥉</div>
                  <div className="prize-place">3. MIEJSCE</div>
                  <div className="prize-image">
                    <img src="/images/3-miejsce.png" alt="Nagroda za 3. miejsce" />
                  </div>
                  <div className="prize-text">
                    Micha Pupila<br/><strong>na tydzień</strong>
                  </div>
                </div>
              </div>
              
              <button className="prizes-cta" onClick={() => setCurrentView('quiz-start')}>
                🎮 Zagraj i wygraj!
              </button>
            </>
          )}
        </div>
      </section>

      {/* Gift Sets Section */}
      <section className="gift-sets-section">
        <div className="section-container">
          <h2 className="section-title">Zestawy <span>prezentowe</span> 🎁</h2>
          <p className="section-subtitle">Idealne pod choinkę dla każdego pupila!</p>
          
          <div className="gift-sets-slider-container">
            <button className="slider-arrow slider-arrow-left" onClick={() => {
              const slider = document.querySelector('.gift-sets-slider');
              slider.scrollBy({ left: -320, behavior: 'smooth' });
            }}>❮</button>
            
            <div className="gift-sets-slider">
              {giftSets.map(set => (
                <div className="gift-set-card" key={set.id}>
                  <div className="gift-set-card-inner">
                    {set.image ? (
                      <div className="gift-set-image">
                        <img src={set.image} alt={set.name} />
                      </div>
                    ) : (
                      <div className="gift-set-icon-wrapper">
                        <span className="gift-set-icon">{set.icon}</span>
                      </div>
                    )}
                    <h4>{set.name}</h4>
                    <p>{set.description}</p>
                    <a href="https://sklep.michapupila.pl" className="gift-set-btn" target="_blank" rel="noopener noreferrer">
                      ZAMÓW
                    </a>
                  </div>
                </div>
              ))}
            </div>
            
            <button className="slider-arrow slider-arrow-right" onClick={() => {
              const slider = document.querySelector('.gift-sets-slider');
              slider.scrollBy({ left: 320, behavior: 'smooth' });
            }}>❯</button>
          </div>
        </div>
      </section>

      {/* Bingo Teaser Section */}
      <section className="bingo-teaser-section">
        <div className="section-container">
          <div className="bingo-teaser-card">
            <div className="bingo-teaser-content">
              <span className="bingo-teaser-emoji">🎯</span>
              <h2>Świąteczne Bingo</h2>
              <p>Wykonuj proste zadania przez cały grudzień i zbieraj rabaty! Im więcej zadań wykonasz, tym większą zniżkę otrzymasz na kolejne zamówienie.</p>
              <div className="bingo-deadline-info">
                ⏰ <strong>Bingo trwa do 31 grudnia!</strong>
              </div>
              <div className="bingo-teaser-rewards">
                <span>6 zadań = <strong>15%</strong></span>
                <span>7 zadań = <strong>20%</strong></span>
                <span>8 zadań = <strong>30%!</strong></span>
              </div>
              <button className="bingo-teaser-btn" onClick={() => setCurrentView('bingo')}>
                🎯 Zagraj w Bingo
              </button>
            </div>
            <div className="bingo-teaser-image">
              <img src="/images/bingo-icon.png" alt="Bingo" />
            </div>
          </div>
        </div>
      </section>

      {/* How it Works */}
      <section className="how-section">
        <div className="section-container">
          <h2 className="section-title">Jak <span>zagrać</span>? 🚀</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-icon">🛒</div>
              <h4>Zamów Michę</h4>
              <p>Twój pupil i tak Ci podziękuje</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-icon">📧</div>
              <h4>Znajdź ID</h4>
              <p>Jest w mailu z potwierdzeniem</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-icon">🎮</div>
              <h4>Zagraj z pupilem</h4>
              <p>Niech kibicuje!</p>
            </div>
            <div className="step-arrow">→</div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-icon">🎁</div>
              <h4>Otwórzcie prezenty</h4>
              <p>Razem smakują lepiej!</p>
            </div>
          </div>
        </div>
      </section>

      {/* Leaderboard Preview */}
      <section className="leaderboard-section">
        <div className="section-container">
          <h2 className="section-title">
            {isQuizEnded() ? 'Pełna <span>tabela wyników</span> 📋' : 'Lista <span>Wygranych</span> 🏆'}
          </h2>
          <p className="section-subtitle">
            {isQuizEnded() 
              ? 'Dziękujemy wszystkim za udział w Świątecznym Quizie! 🎄' 
              : 'Pupile z TOP 3 znajdą pod choinką pełen zestaw świątecznych pyszności! 🎄'}
          </p>
          
          <div className="leaderboard-card">
            <div className="leaderboard-header">
              <h3>{isQuizEnded() ? '🏆 Końcowe wyniki quizu' : '🎅 Lista Świętego Mikołaja'}</h3>
            </div>
            <div className="leaderboard-list">
              {leaderboard.slice(0, isQuizEnded() ? 10 : 5).map((entry, index) => (
                <div className="leaderboard-row" key={index}>
                  <div className={`leaderboard-rank ${index === 0 ? 'gold' : index === 1 ? 'silver' : index === 2 ? 'bronze' : ''}`}>
                    {index < 3 ? ['🥇', '🥈', '🥉'][index] : index + 1}
                  </div>
                  <div className="leaderboard-avatar">
                    {entry.petType === 'cat' ? '🐈' : '🐕'}
                  </div>
                  <div className="leaderboard-info">
                    <div className="leaderboard-name">{entry.petName || 'Pupil'}</div>
                    <div className="leaderboard-player">{entry.playerName || 'Anonim'}</div>
                  </div>
                  <div className="leaderboard-score">{entry.score}/{entry.totalQuestions || CONFIG.questionsCount}</div>
                  <div className="leaderboard-time">{entry.totalTime}s</div>
                </div>
              ))}
              {leaderboard.length === 0 && (
                <div className="leaderboard-empty">
                  Bądź pierwszy na liście! 🏆
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      {isQuizEnded() ? (
        <section className="cta-bingo-section" onClick={() => setCurrentView('bingo')}>
          <div className="cta-bingo-content">
            <h2>🎯 Quiz się zakończył, ale Bingo trwa!</h2>
            <p>Wykonuj zadania do 31 grudnia i zdobądź do 30% rabatu!</p>
            <button className="cta-bingo-btn">Zagraj w Bingo →</button>
          </div>
        </section>
      ) : (
        <section className="cta-image-section" onClick={() => setCurrentView('quiz-start')}>
          <img src="/images/swieta-footer.jpg" alt="Brakuje Cię na liście Mikołaja? Zagraj jeszcze raz!" className="cta-footer-image" />
        </section>
      )}

      {/* Promo Banner - ZMIENIONY */}
      <div className="promo-banner">
        <span>🎄 Zamów do <strong>19.12 do 9:00</strong>, a paczkę otrzymasz w Wigilijny poranek!</span>
      </div>
    </div>
  );

  const renderQuizStart = () => {
    // Jeśli quiz się zakończył, pokaż informację
    if (isQuizEnded()) {
      return (
        <div className="quiz-start-container">
          <button className="back-button" onClick={() => setCurrentView('home')}>← Powrót</button>
          
          <div className="quiz-start-card quiz-ended-card">
            <div className="quiz-start-header">
              <h1>🏁 Quiz Zakończony!</h1>
              <p>Świąteczny Quiz dobiegł końca 26 grudnia 2025.</p>
            </div>
            
            <div className="quiz-ended-info">
              <div className="quiz-ended-icon">🎄</div>
              <h2>Dziękujemy za udział!</h2>
              <p>Gratulujemy wszystkim uczestnikom i zwycięzcom!</p>
              <p>Sprawdź wyniki na stronie głównej.</p>
              
              <div className="quiz-ended-cta">
                <button className="btn btn-primary" onClick={() => setCurrentView('home')}>
                  🏆 Zobacz wyniki
                </button>
                <p style={{marginTop: '20px', fontSize: '0.9rem', color: '#666'}}>
                  Pamiętaj - Bingo trwa do 31 grudnia!
                </p>
                <button className="btn btn-secondary" onClick={() => setCurrentView('bingo')} style={{marginTop: '10px'}}>
                  🎯 Zagraj w Bingo
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
    <div className="quiz-start-container">
      <button className="back-button" onClick={() => setCurrentView('home')}>← Powrót</button>
      
      <div className="quiz-start-card">
        <div className="quiz-start-header">
          <h1>🎄 Świąteczny Quiz</h1>
          <p>Sprawdź swoją wiedzę o pupilach i wygraj nagrody!</p>
        </div>

        <div className="quiz-form">
          <div className="form-group">
            <label>Numer zamówienia *</label>
            <input
              type="text"
              value={orderId}
              onChange={(e) => {
                setOrderId(e.target.value);
                setIsValidOrder(false);
                setMaxAttemptsReached(false);
              }}
              onBlur={validateOrderId}
              placeholder="np. 12345"
              className={isValidOrder ? 'valid' : orderId.length > 3 ? 'invalid' : ''}
            />
            {orderId.length > 3 && !isValidOrder && !isLoading && (
              <span className="error-text">Nieprawidłowy numer zamówienia</span>
            )}
            {isValidOrder && (
              <span className="success-text">✓ Zamówienie potwierdzone</span>
            )}
          </div>

          <div className="form-group">
            <label>
              ID Klienta 
              <span 
                onClick={() => setShowCustomerIdHelp(true)}
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '18px',
                  height: '18px',
                  marginLeft: '6px',
                  background: '#3D5A73',
                  color: 'white',
                  borderRadius: '50%',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  cursor: 'pointer'
                }}
              >
                ?
              </span>
            </label>
            <input
              type="text"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
              placeholder="np. 422 (opcjonalne)"
            />
          </div>

          <div className="form-group">
            <label>Twoje imię *</label>
            <input
              type="text"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              placeholder="np. Anna"
            />
          </div>

          <div className="form-group">
            <label>Imię pupila *</label>
            <input
              type="text"
              value={petName}
              onChange={(e) => setPetName(e.target.value)}
              placeholder="np. Luna"
            />
          </div>

          <div className="form-group">
            <label>Typ pupila</label>
            <div className="pet-type-selector">
              <button
                className={`pet-type-btn ${petType === 'dog' ? 'active' : ''}`}
                onClick={() => setPetType('dog')}
              >
                🐕 Pies
              </button>
              <button
                className={`pet-type-btn ${petType === 'cat' ? 'active' : ''}`}
                onClick={() => setPetType('cat')}
              >
                🐈 Kot
              </button>
            </div>
          </div>

          {isValidOrder && (
            <div className="attempts-info">
              <span>Wykorzystane próby: {attempts}/{CONFIG.maxAttempts}</span>
            </div>
          )}

          {maxAttemptsReached ? (
            <div className="max-attempts-message">
              <p>😿 Wykorzystałeś wszystkie próby dla tego zamówienia.</p>
              <p>Złóż nowe zamówienie, aby zagrać ponownie!</p>
              <a href="https://sklep.michapupila.pl" className="shop-link">
                🛒 Przejdź do sklepu
              </a>
            </div>
          ) : (
            <button
              className="start-quiz-btn"
              onClick={startQuiz}
              disabled={!isValidOrder || !playerName || !petName || isLoading}
            >
              {isLoading ? '⏳ Ładowanie...' : '🎮 Rozpocznij Quiz'}
            </button>
          )}
        </div>

        <div className="quiz-rules">
          <h4>📋 Zasady:</h4>
          <ul>
            <li>🎄 10 pytań o świątecznym żywieniu pupili</li>
            <li>⏱️ {CONFIG.timePerQuestion} sekund na odpowiedź</li>
            <li>🔄 {CONFIG.maxAttempts} próby na jedno zamówienie</li>
            <li>🏆 Wygrywa najszybszy znawca pupili!</li>
          </ul>
        </div>
      </div>

      {/* Modal pomocy - gdzie znaleźć ID klienta */}
      {showCustomerIdHelp && (
        <div className="modal-overlay" onClick={() => setShowCustomerIdHelp(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <button className="modal-close" onClick={() => setShowCustomerIdHelp(false)}>×</button>
            <h3>🔍 Gdzie znaleźć ID Klienta?</h3>
            
            <p style={{ marginBottom: '15px' }}>
              ID klienta znajdziesz w swoim koncie w sklepie Micha Pupila:
            </p>
            
            <div style={{ marginBottom: '15px', textAlign: 'center' }}>
              <img 
                src="/images/id-konta.png" 
                alt="Gdzie znaleźć ID klienta" 
                style={{ 
                  maxWidth: '100%', 
                  borderRadius: '8px',
                  border: '1px solid #ddd',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }} 
              />
            </div>
            
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '15px' }}>
              Wejdź w <strong>Moje konto</strong> → <strong>Ustawienia konta</strong> → pole <strong>ID</strong>
            </p>
            
            <a 
              href="https://sklep.michapupila.pl/my-account/account-settings" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#3D5A73',
                color: 'white',
                padding: '12px 24px',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: 'bold',
                marginTop: '10px'
              }}
            >
              🔗 Otwórz ustawienia konta
            </a>
          </div>
        </div>
      )}
    </div>
  );
  };

  // ==================== RENDER QUIZ (BEZPIECZNY - BEZ POKAZYWANIA ODPOWIEDZI) ====================
  const renderQuiz = () => {
    const question = quizQuestions[currentQuestion];
    if (!question) return null;

    const timerClass = timeLeft <= 3 ? 'danger' : timeLeft <= 5 ? 'warning' : '';
    const letters = ['A', 'B', 'C', 'D'];

    return (
      <div className="quiz-container">
        <div className="quiz-header">
          <div className="quiz-progress">
            <span>🎄 Pytanie {currentQuestion + 1}/{quizQuestions.length}</span>
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${((currentQuestion + 1) / quizQuestions.length) * 100}%` }}
              />
            </div>
          </div>
          <div className={`quiz-timer ${timerClass}`}>
            ⏱️ {timeLeft}s
          </div>
        </div>

        <div className="quiz-question">
          <h2>{question.question}</h2>
        </div>

        <div className="quiz-answers">
          {question.answers.map((answer, index) => {
            let answerClass = 'quiz-answer';
            // NIE pokazujemy która odpowiedź była poprawna!
            if (isAnswered && answers[currentQuestion]?.answerIndex === index) {
              answerClass += ' selected';
            }
            
            return (
              <button
                key={index}
                className={answerClass}
                onClick={() => handleAnswer(index)}
                disabled={isAnswered}
              >
                <span className="answer-letter">{letters[index]}.</span> {answer}
              </button>
            );
          })}
        </div>

        <div className="quiz-score">
          Pytanie: {currentQuestion + 1}/{quizQuestions.length}
        </div>
      </div>
    );
  };

  // ==================== RENDER RESULTS ====================
  const renderResults = () => {
    const totalTime = quizResults?.totalTime || (quizEndTime ? ((quizEndTime - quizStartTime) / 1000).toFixed(1) : 0);
    const finalScore = quizResults?.score || score;
    const totalQuestions = quizResults?.totalQuestions || CONFIG.questionsCount;
    const percentage = Math.round((finalScore / totalQuestions) * 100);
    
    let resultMessage = '';
    if (percentage >= 80) {
      resultMessage = 'Wow! Twój pupil ma najlepszego opiekuna na świecie! 🏆';
    } else if (percentage >= 50) {
      resultMessage = 'Nieźle! Twój pupil może być z Ciebie dumny! 👏';
    } else {
      resultMessage = 'Twój pupil Cię kocha, nawet jeśli quiz poszedł średnio! 💪';
    }

    return (
      <div className="results-container">
        <div className="results-card">
          <div className="results-header">
            {percentage >= 80 ? '🏆' : percentage >= 50 ? '👏' : '💪'}
            <h1>Quiz zakończony!</h1>
          </div>
          
          <p className="results-message">{quizResults?.message || resultMessage}</p>

          <div className="results-stats">
            <div className="stat-item">
              <div className="stat-value">{finalScore}/{totalQuestions}</div>
              <div className="stat-label">Poprawne odpowiedzi</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{totalTime}s</div>
              <div className="stat-label">Całkowity czas</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{percentage}%</div>
              <div className="stat-label">Skuteczność</div>
            </div>
          </div>

          {playerRank && playerRank <= 3 && (
            <div className="results-podium">
              🎉 Gratulacje! Jesteś na {playerRank}. miejscu na Liście Mikołaja!
            </div>
          )}

          {playerRank && playerRank > 3 && (
            <div className="results-rank">
              Twoje miejsce na Liście Mikołaja: <strong>{playerRank}</strong>
            </div>
          )}

          {/* Szczegółowe wyniki - pokazywane PO zakończeniu */}
          {quizResults?.detailedResults && (
            <div className="detailed-results" style={{ margin: '20px 0', padding: '15px', background: '#f5f5f5', borderRadius: '8px' }}>
              <h4 style={{ marginBottom: '10px' }}>Twoje odpowiedzi:</h4>
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: 'center' }}>
                {quizResults.detailedResults.map((result, index) => (
                  <span 
                    key={index} 
                    style={{
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '50%',
                      background: result.wasCorrect ? '#27ae60' : '#e74c3c',
                      color: 'white',
                      fontWeight: 'bold'
                    }}
                    title={`Pytanie ${index + 1}: ${result.wasCorrect ? 'Poprawna' : 'Błędna'}`}
                  >
                    {result.wasCorrect ? '✓' : '✗'}
                  </span>
                ))}
              </div>
            </div>
          )}

          <div className="results-actions">
            <button className="results-btn primary" onClick={() => setCurrentView('santa-gifts')}>
              🎅 Odbierz prezent od Mikołaja
            </button>
            <button className="results-btn secondary" onClick={() => setCurrentView('home')}>
              🏠 Strona główna
            </button>
            {attempts < CONFIG.maxAttempts && (
              <button className="results-btn tertiary" onClick={() => setCurrentView('quiz-start')}>
                🔄 Spróbuj ponownie ({CONFIG.maxAttempts - attempts} {CONFIG.maxAttempts - attempts === 1 ? 'próba' : 'próby'})
              </button>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderSantaGifts = () => {
    const hasCompletedQuiz = completedTasks.includes(5);
    const prizeToShow = selectedPrize || claimedPrize;
    
    return (
      <div className="santa-gifts-container">
        <button className="back-button" onClick={() => setCurrentView('home')}>← Powrót</button>
        
        {!hasCompletedQuiz ? (
          <div className="santa-locked">
            <div className="santa-locked-card">
              <span className="santa-locked-icon">🎅🔒</span>
              <h2>Mikołaj czeka na Ciebie!</h2>
              <p>Najpierw ukończ Świąteczny Quiz, a potem wróć po prezent od Mikołaja!</p>
              <button className="santa-locked-btn" onClick={() => setCurrentView('quiz-start')}>
                🎮 Zagraj w Quiz
              </button>
            </div>
          </div>
        ) : hasClaimedGift && prizeToShow ? (
          <div className="gift-result">
            <div className="gift-result-card">
              <h2>🎁 Twój prezent od Mikołaja</h2>
              <div className="gift-result-image">
                <img src={prizeToShow.image || '/images/box-10.png'} alt="Twoja nagroda" />
              </div>
              <div className="gift-result-prize">
                <div className="prize-label">Twoja nagroda:</div>
                <div className="prize-name">{prizeToShow.label}</div>
              </div>
              <div className="gift-result-code">
                <div className="code-label">Kod rabatowy</div>
                <div className="code-value">{prizeToShow.code}</div>
              </div>
              <button className="copy-code-btn" onClick={copyPrizeCode}>
                📋 Skopiuj kod
              </button>
              <p className="gift-note">Kod ważny do 26.12.2025</p>
              
              <button className="results-btn secondary" onClick={() => setCurrentView('home')}>
                🏠 Strona główna
              </button>
            </div>
          </div>
        ) : !showGiftResult ? (
          <div className="santa-selection">
            <img src="/images/mikolaj.jpg" alt="Mikołaj rozdaje prezenty" className="santa-image" />
            
            <div className="gifts-overlay">
              <button className="gift-button" onClick={() => selectGift(0)} disabled={hasClaimedGift}>
                <span className="gift-hint">👆</span>
              </button>
              <button className="gift-button" onClick={() => selectGift(1)} disabled={hasClaimedGift}>
                <span className="gift-hint">👆</span>
              </button>
              <button className="gift-button" onClick={() => selectGift(2)} disabled={hasClaimedGift}>
                <span className="gift-hint">👆</span>
              </button>
            </div>

            {!hasClaimedGift && (
              <p className="santa-hint">👆 Kliknij na wybrany prezent!</p>
            )}
          </div>
        ) : (
          <div className="gift-result">
            <div className="gift-result-card">
              <h2>🎉 Gratulacje!</h2>
              <div className="gift-result-image">
                <img src={prizeToShow?.image || '/images/box-10.png'} alt="Twoja nagroda" />
              </div>
              <div className="gift-result-prize">
                <div className="prize-label">Twoja nagroda:</div>
                <div className="prize-name">{prizeToShow?.label}</div>
              </div>
              <div className="gift-result-code">
                <div className="code-label">Kod rabatowy</div>
                <div className="code-value">{prizeToShow?.code}</div>
              </div>
              <button className="copy-code-btn" onClick={copyPrizeCode}>
                📋 Skopiuj kod
              </button>
              <p className="gift-note">Kod ważny do 26.12.2025</p>
              
              <button className="results-btn secondary" onClick={() => setCurrentView('home')}>
                🏠 Strona główna
              </button>
            </div>

            <div className="confetti-container">
              {[...Array(30)].map((_, i) => (
                <div 
                  key={i} 
                  className="confetti" 
                  style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 2}s`,
                    backgroundColor: ['#C41E3A', '#3D5A73', '#F5B800', '#27ae60'][Math.floor(Math.random() * 4)]
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {showGiftAnimation && (
          <div className="gift-opening-overlay">
            <div className="gift-opening">
              <span className="gift-box-animated">🎁</span>
              <div className="sparkles">
                {[...Array(12)].map((_, i) => (
                  <span 
                    key={i} 
                    className="sparkle"
                    style={{
                      '--angle': `${(i / 12) * 360}deg`,
                      '--delay': `${i * 0.05}s`
                    }}
                  >
                    ✨
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderBingo = () => {
    const reward = getBingoReward();
    const progress = (completedTasks.length / bingoTasks.length) * 100;

    return (
      <div className="bingo-container">
        <button className="back-button" onClick={() => setCurrentView('home')}>← Powrót</button>
        
        <div className="bingo-content">
          <div className="bingo-info">
            <h1>🎯 Świąteczne Bingo</h1>
            <p>Wykonuj zadania przez cały grudzień i zbieraj rabaty!</p>
            
            {reward && (
              <div className="bingo-reward">
                <span className="reward-icon">🏆</span>
                <div className="reward-text">
                  <strong>{reward.discount} rabatu</strong>
                  <span>{reward.label}</span>
                </div>
              </div>
            )}

            <div className="bingo-progress">
              <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${progress}%` }} />
              </div>
              <span>{completedTasks.length} z {bingoTasks.length} zadań</span>
            </div>
          </div>

          <div className="bingo-user-form">
            <h4>📋 Twoje dane do weryfikacji</h4>
            <div className="bingo-form-row">
              <div className="form-group">
                <label>ID Klienta *</label>
                <input
                  type="text"
                  value={bingoCustomerId}
                  onChange={(e) => setBingoCustomerId(e.target.value)}
                  placeholder="np. 15740"
                />
              </div>
              <div className="form-group">
                <label>Email</label>
                <input
                  type="email"
                  value={bingoEmail}
                  onChange={(e) => setBingoEmail(e.target.value)}
                  placeholder="twoj@email.pl"
                />
              </div>
              <div className="form-group">
                <label>Imię</label>
                <input
                  type="text"
                  value={bingoName}
                  onChange={(e) => setBingoName(e.target.value)}
                  placeholder="Twoje imię"
                />
              </div>
            </div>
          </div>

          <div className="bingo-card">
            <div className="bingo-grid bingo-grid-8">
              {bingoTasks.map(task => (
                <div 
                  key={task.id}
                  className={`bingo-cell ${completedTasks.includes(task.id) ? 'completed' : ''}`}
                  onClick={() => handleBingoClick(task)}
                >
                  <span className="bingo-cell-icon">{task.icon}</span>
                  <span className="bingo-cell-label">{task.label}</span>
                  {completedTasks.includes(task.id) && (
                    <span className="bingo-checkmark">✓</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {completedTasks.length >= 6 && (
            <div className="bingo-submit-section">
              {bingoSubmitted ? (
                <div className="bingo-submitted-message">
                  ✅ Twoje Bingo zostało wysłane do weryfikacji! Sprawdzimy Twoje zamówienia i skontaktujemy się z Tobą.
                </div>
              ) : (
                <button 
                  className="bingo-submit-btn"
                  onClick={() => setShowBingoSubmitModal(true)}
                  disabled={!bingoCustomerId}
                >
                  📤 Wyślij Bingo do weryfikacji
                </button>
              )}
            </div>
          )}

          <div className="bingo-rewards-info">
            <h4>Nagrody:</h4>
            <ul>
              <li>6 zadań = <strong>15% rabatu</strong></li>
              <li>7 zadań = <strong>20% rabatu</strong></li>
              <li>Wszystkie 8 = <strong>30% rabatu! 🎁</strong></li>
            </ul>
          </div>
        </div>

        {/* Modal Facebook */}
        {showFacebookModal && (
          <div className="modal-overlay" onClick={() => setShowFacebookModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowFacebookModal(false)}>×</button>
              <h3>👍 Polub nas na Facebooku</h3>
              <p>Dołącz do naszej społeczności miłośników pupili!</p>
              
              <div style={{ margin: '20px 0', textAlign: 'center' }}>
                <a 
                  href="https://www.facebook.com/michapupilapl" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    background: '#1877F2',
                    color: 'white',
                    padding: '14px 28px',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    boxShadow: '0 2px 8px rgba(24, 119, 242, 0.4)'
                  }}
                >
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="white">
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                  </svg>
                  Otwórz stronę na Facebooku
                </a>
              </div>
              
              <div style={{ 
                background: '#f8f9fa', 
                padding: '15px', 
                borderRadius: '8px', 
                margin: '15px 0',
                fontSize: '14px',
                color: '#555'
              }}>
                <strong>Instrukcja:</strong><br/>
                1. Kliknij przycisk powyżej<br/>
                2. Polub naszą stronę na Facebooku<br/>
                3. Wróć tutaj i kliknij "Gotowe"
              </div>
              
              <button 
                className="modal-confirm-btn"
                onClick={() => {
                  toggleBingoTask(6);
                  setShowFacebookModal(false);
                }}
              >
                ✓ Gotowe, polubiłem!
              </button>
            </div>
          </div>
        )}

        {/* Modal Newsletter */}
        {showNewsletterModal && (
          <div className="modal-overlay" onClick={() => setShowNewsletterModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowNewsletterModal(false)}>×</button>
              <h3>📧 Dołącz do newslettera</h3>
              <p>Zapisz się i odbieraj świąteczne promocje dla pupila!</p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Twój email" 
                  value={newsletterEmail}
                  onChange={(e) => setNewsletterEmail(e.target.value)}
                />
                <button 
                  className="newsletter-submit-btn"
                  onClick={handleNewsletterSubmit}
                  disabled={isSubmittingNewsletter}
                >
                  {isSubmittingNewsletter ? '⏳ Zapisuję...' : '📬 Zapisz się'}
                </button>
              </div>
              {newsletterSuccess && (
                <p className="newsletter-success">✅ Dziękujemy za zapis! Sprawdź swoją skrzynkę.</p>
              )}
            </div>
          </div>
        )}

        {/* Modal Bingo Submit */}
        {showBingoSubmitModal && (
          <div className="modal-overlay" onClick={() => setShowBingoSubmitModal(false)}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setShowBingoSubmitModal(false)}>×</button>
              <h3>📤 Wyślij Bingo do weryfikacji</h3>
              
              <div className="bingo-submit-summary">
                <p><strong>ID Klienta:</strong> {bingoCustomerId}</p>
                <p><strong>Email:</strong> {bingoEmail || 'Nie podano'}</p>
                <p><strong>Ukończone zadania:</strong> {completedTasks.length}/{bingoTasks.length}</p>
                <p><strong>Oczekiwany rabat:</strong> {reward?.discount || 'Brak'}</p>
              </div>
              
              <p className="bingo-submit-note">
                Sprawdzimy czy spełniasz wymagania (zamówienia, polubienia itp.) i wyślemy Ci kod rabatowy na email.
              </p>
              
              {bingoSubmitSuccess ? (
                <p className="newsletter-success">✅ Bingo wysłane! Sprawdzimy i odezwiemy się.</p>
              ) : (
                <button 
                  className="modal-confirm-btn"
                  onClick={handleBingoSubmit}
                  disabled={isSubmittingBingo || !bingoCustomerId}
                >
                  {isSubmittingBingo ? '⏳ Wysyłam...' : '📤 Potwierdź i wyślij'}
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  // ==================== REGULAMIN ====================
  const renderRegulamin = () => {
    return (
      <div className="regulamin-page">
        <div className="regulamin-container">
          <div className="section-divider">
            <span className="divider-icon">📜</span>
          </div>
          <h1 className="regulamin-title">REGULAMIN</h1>

          <div className="regulamin-content expanded">
            <div className="regulamin-header">
              <h3>Regulamin Promocji „Świąteczny Quiz i Bingo – Micha Pupila"</h3>
              <p className="regulamin-subtitle">(obowiązuje na stronie https://swieta.michapupila.pl)</p>
            </div>

            <div className="regulamin-article">
              <h4>1. Postanowienia ogólne</h4>
              <ol>
                <li>Organizatorem promocji („Promocja") jest PETFUSION Sp. z o.o., NIP: 578 315 50 97, KRS: 0001166336, REGON: 522 325 525, ul. Młynarska 42/115, 01-171 Warszawa.</li>
                <li>Promocja trwa od <strong>1 grudnia 2025 r. do 26 grudnia 2025 r.</strong></li>
                <li>Promocja prowadzona jest na terytorium Rzeczypospolitej Polskiej za pośrednictwem strony https://swieta.michapupila.pl.</li>
                <li>Promocja nie jest grą losową, loterią fantową ani zakładem wzajemnym w rozumieniu ustawy o grach hazardowych.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>2. Uczestnictwo</h4>
              <ol>
                <li>Uczestnikiem może być każda pełnoletnia osoba fizyczna zamieszkała na terenie Polski.</li>
                <li>Warunkiem uczestnictwa jest posiadanie opłaconego zamówienia z indywidualnym ID zamówienia. Za kwalifikujące się zamówienie uznaje się: plan subskrypcyjny na 14 lub 28 dni albo zamówienie jednorazowe o wartości min. 49,99 zł. Zamówienia anulowane nie uprawniają do udziału.</li>
                <li>Udział w Promocji jest dobrowolny i bezpłatny.</li>
                <li>Warunkiem udziału jest wypełnienie quizu oraz podanie prawidłowych danych kontaktowych.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>3. Zasady Quizu</h4>
              <ol>
                <li>Uczestnik rozwiązuje quiz dostępny na stronie https://swieta.michapupila.pl.</li>
                <li>Wynik quizu decyduje o przyznaniu nagród za miejsca 1–3.</li>
                <li>Organizator może weryfikować ID zamówienia wskazane przez uczestnika.</li>
                <li>Każdy uczestnik może wziąć udział w quizie maksymalnie dwa razy.</li>
                <li>Organizator może wykluczyć uczestników naruszających regulamin lub podających nieprawdziwe dane.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>4. Zasady Bingo</h4>
              <ol>
                <li>Świąteczne Bingo to dodatkowa aktywność promocyjna dostępna na stronie https://swieta.michapupila.pl.</li>
                <li>Bingo składa się z 8 zadań do wykonania:
                  <ul>
                    <li>Złóż zamówienie (w terminie 1-26.12) – plan subskrypcyjny na 14 lub 28 dni albo zamówienie jednorazowe o wartości min. 49,99 zł</li>
                    <li>Zamów suplement</li>
                    <li>Zamów przysmak</li>
                    <li>Poleć nas znajomemu</li>
                    <li>Ukończ Quiz</li>
                    <li>Polub nas na Facebooku</li>
                    <li>Zapisz się do newslettera</li>
                    <li>Złóż 2 zamówienia w grudniu – każde zamówienie musi spełniać warunki z punktu pierwszego</li>
                  </ul>
                </li>
                <li>Nagrody w Bingo zależą od liczby ukończonych zadań:
                  <ul>
                    <li><strong>6 zadań:</strong> kod rabatowy 15%</li>
                    <li><strong>7 zadań:</strong> kod rabatowy 20%</li>
                    <li><strong>8 zadań:</strong> kod rabatowy 30%</li>
                  </ul>
                </li>
                <li>Po ukończeniu wymaganej liczby zadań uczestnik wysyła zgłoszenie do weryfikacji.</li>
                <li>Organizator weryfikuje wykonanie zadań i przyznaje odpowiedni kod rabatowy.</li>
                <li>Kod rabatowy zostanie wysłany na adres e-mail podany przez uczestnika.</li>
                <li>Kody rabatowe są jednorazowe i ważne przez 30 dni od daty wysłania.</li>
                <li>Kody rabatowe nie łączą się z innymi promocjami.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>5. Nagrody w Quizie</h4>
              <ol>
                <li>Nagrodami w Promocji są:
                  <ul>
                    <li><strong>1 miejsce:</strong> zestaw karmy dla psa lub kota odpowiadający 1 miesiącowi żywienia, o łącznej maksymalnej ilości do 400 g,</li>
                    <li><strong>2 miejsce:</strong> zestaw karmy dla psa lub kota odpowiadający 2 tygodniom żywienia, o łącznej maksymalnej ilości do 400 g,</li>
                    <li><strong>3 miejsce:</strong> zestaw karmy dla psa lub kota odpowiadający 1 tygodniowi żywienia, o łącznej maksymalnej ilości do 400 g.</li>
                  </ul>
                </li>
                <li>Nagrody mają charakter symboliczny i nie stanowią pełnych porcji żywieniowych zwierzęcia.</li>
                <li>Nagrody nie podlegają wymianie na ekwiwalent pieniężny lub inne świadczenia.</li>
                <li>Wysyłka nagród nastąpi w ciągu 30 dni od potwierdzenia danych przez uczestnika.</li>
                <li>Koszt wysyłki pokrywa Organizator.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>6. Odbiór nagród</h4>
              <ol>
                <li>Uczestnik otrzyma e-mail lub SMS z prośbą o potwierdzenie danych wysyłkowych.</li>
                <li>Brak potwierdzenia w ciągu 7 dni powoduje utratę prawa do nagrody.</li>
                <li>Organizator nie odpowiada za niedoręczenie nagrody wynikające z błędnych danych podanych przez uczestnika.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>7. Dane osobowe</h4>
              <ol>
                <li>Administratorem danych jest PETFUSION Sp. z o.o.</li>
                <li>Dane są przetwarzane wyłącznie w celu obsługi Promocji.</li>
                <li>Podstawą przetwarzania jest zgoda uczestnika oraz prawnie uzasadniony interes Organizatora.</li>
                <li>Dane będą przechowywane przez okres niezbędny do realizacji Promocji.</li>
                <li>Uczestnik ma prawo do dostępu do danych i żądania ich poprawienia, usunięcia lub ograniczenia przetwarzania.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>8. Reklamacje</h4>
              <ol>
                <li>Reklamacje można zgłaszać pisemnie na adres: PETFUSION Sp. z o.o., ul. Młynarska 42/115, 01-171 Warszawa lub mailowo na hello@michapupila.pl.</li>
                <li>Reklamacje można składać w ciągu 14 dni od zakończenia Promocji.</li>
                <li>Organizator rozpatrzy reklamację w ciągu 14 dni.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>9. Odpowiedzialność</h4>
              <ol>
                <li>Organizator nie ponosi odpowiedzialności za przerwy techniczne oraz działania uczestników uniemożliwiające udział w Promocji.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>10. Zmiany Regulaminu</h4>
              <ol>
                <li>Organizator może zmienić Regulamin z ważnych powodów bez naruszania praw nabytych uczestników.</li>
                <li>Aktualna treść Regulaminu jest dostępna na stronie https://swieta.michapupila.pl.</li>
              </ol>
            </div>

            <div className="regulamin-article">
              <h4>11. Postanowienia końcowe</h4>
              <ol>
                <li>W sprawach nieuregulowanych stosuje się przepisy prawa polskiego.</li>
                <li>Regulamin wchodzi w życie z dniem publikacji na stronie.</li>
              </ol>
            </div>
          </div>

          <button 
            className="btn btn-secondary"
            onClick={() => setCurrentView('home')}
            style={{ marginTop: '30px' }}
          >
            ← Wróć do strony głównej
          </button>
        </div>
      </div>
    );
  };

  // ==================== GŁÓWNY RENDER ====================
  return (
    <div className="app">
      {/* Navigation */}
      <nav className="nav">
        <div className="nav-logo" onClick={() => setCurrentView('home')}>
          <img src="/logo.png" alt="Micha Pupila" className="logo-image" onError={(e) => {
            e.target.style.display = 'none';
            e.target.nextSibling.style.display = 'block';
          }} />
          <span className="logo-text" style={{ display: 'none' }}>MICHA PUPILA</span>
        </div>
        <div className="nav-links">
          <a onClick={() => setCurrentView('home')}>Start</a>
          <a onClick={() => setCurrentView('quiz-start')}>Quiz</a>
          <a onClick={() => setCurrentView('santa-gifts')}>Mikołaj</a>
          <a onClick={() => setCurrentView('bingo')}>Bingo</a>
          <a onClick={() => setCurrentView('home')}>Ranking</a>
          <a onClick={() => setCurrentView('regulamin')}>Regulamin</a>
          <a href="https://michapupila.pl">Strona główna</a>
        </div>
        <button className="nav-cta" onClick={() => setCurrentView('quiz-start')}>
          🎄 Zagraj teraz
        </button>
      </nav>

      {/* Main Content */}
      <main className="main-content">
        {currentView === 'home' && renderHome()}
        {currentView === 'quiz-start' && renderQuizStart()}
        {currentView === 'quiz' && renderQuiz()}
        {currentView === 'results' && renderResults()}
        {currentView === 'santa-gifts' && renderSantaGifts()}
        {currentView === 'bingo' && renderBingo()}
        {currentView === 'regulamin' && renderRegulamin()}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="nav-logo">
              <img src="/logo.png" alt="Micha Pupila" className="logo-image" onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }} />
              <span className="logo-text" style={{ display: 'none' }}>MICHA PUPILA</span>
            </div>
          </div>
          <div className="footer-links">
            <a href="https://sklep.michapupila.pl">Sklep</a>
            <a href="https://michapupila.pl">Strona główna</a>
            <a onClick={() => setCurrentView('regulamin')} style={{ cursor: 'pointer' }}>Regulamin</a>
            <a href="mailto:hello@michapupila.pl">Kontakt</a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2025 Micha Pupila. Wesołych Świąt! 🎄</p>
        </div>
      </footer>

      {/* Snowfall */}
      <div className="snowfall">
        {[...Array(15)].map((_, i) => (
          <div 
            key={i} 
            className="snowflake"
            style={{
              left: `${Math.random() * 100}%`,
              animationDuration: `${10 + Math.random() * 10}s`,
              animationDelay: `${Math.random() * 5}s`,
              fontSize: `${8 + Math.random() * 10}px`
            }}
          >
            ❄
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;